import { InferType, object } from 'yup';
import { createStringSchema } from '../validation/schemaFactory';

//* Types and schemas related to the form validation for the Login page
const stringSchema = createStringSchema();

export const LoginValidationSchema = object({
    email: stringSchema.requiredEmail(),
    password: stringSchema.required()
});

export type LoginValidationType = InferType<
  typeof LoginValidationSchema
>;